import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { paletteOptions } from "@portal/app/_components/theme/options/palette";
import { HomepageHeaderTypography } from "@portal/app/HomePage";

const stats = [
  { value: "6,000+", label: "Schools on Dreambound" },
  { value: "130+", label: "Program options" },
  { value: "300,000+", label: "Students matched" },
];

export const HomeStatsSection = () => (
  <Section>
    <ContentWrapper>
      <HomepageHeaderTypography sx={{ color: "white", fontSize: "2.5rem" }}>
        Don&apos;t just dream it.{" "}
        <span style={{ display: "inline-block", whiteSpace: "nowrap" }}>Do it.</span>
      </HomepageHeaderTypography>
      <Typography className="subtext">
        Dreambound helps you plan your move and find what&apos;s next &mdash; for free.
      </Typography>
      <StatsRow>
        {stats.map(({ value, label }, index) => (
          <StatItem key={label}>
            {index > 0 && <StatDivider />}
            <div className="stat_content">
              <Typography className="stat_value">{value}</Typography>
              <Typography className="stat_label">{label}</Typography>
            </div>
          </StatItem>
        ))}
      </StatsRow>
    </ContentWrapper>
  </Section>
);

const Section = styled("section")`
  background: ${paletteOptions.primary.main};
  padding: 5rem 1rem;
  display: flex;
  justify-content: center;
  max-width: 100% !important;
  width: 100%;
`;

const ContentWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 50rem;
  width: 100%;
  color: white;

  .subtext {
    color: rgba(255, 255, 255, 0.95);
    font-size: 1.1rem;
    margin-top: 1rem;
    max-width: 36rem;
    line-height: 1.6;
  }
`;

const StatsRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: 2rem;
  }
`;

const StatItem = styled("div")`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;

  .stat_content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .stat_value {
    font-size: 2.75rem;
    font-weight: 700;
    color: white;
    line-height: 1.1;
  }

  .stat_label {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    margin-top: 0.25rem;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    .stat_value {
      font-size: 2.25rem;
    }
  }
`;

const StatDivider = styled("div")`
  width: 1px;
  height: 3.5rem;
  background: rgba(255, 255, 255, 0.25);
  margin-right: 2rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    display: none;
  }
`;
